<template>
    <button
        :type="type"
        :class="[
            'rounded-lg',
            isMain ? 'bg-indigo-600' : 'bg-gray-600',
            isMain ? 'hover:bg-indigo-500' : 'hover:bg-gray-500',
            'text-white',
            'px-4',
            'py-3',
            'focus:outline-none',
            disabled ? 'opacity-50 cursor-not-allowed' : null,
        ]"
        @click="(e) => $emit('click', e)"
        :disabled="disabled"
    >
        <span v-if="!disabled">{{ content }}</span>
        <span v-if="disabled">{{ disabledContent || content }}</span>
        <span v-if="!content"><slot></slot></span>
    </button>
</template>

<script>
export default {
    name: "Btn",
    props: {
        isMain: Boolean,
        name: String,
        content: String,
        disabledContent: {
            type: String,
            required: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        type:{
            type: String,
            default: "submit"
        }
    },
};
</script>
